import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectLoanActions = createSelector(
  selectLoanApplication,
  ({ loanActions }) => loanActions,
);
